export class DeliverablePartner {
	public partnerId: string;
	public assetId: string;
	public partnerName: string;
	public role: string;
	public modelId?: string;
	public isDeleted?: boolean;
}
